import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";

const TONE = {
  checked_in: "text-primary",
  checked_out: "text-muted-foreground",
  late: "text-destructive",
  absent: "text-destructive",
};

const clock = (value) => (value ? String(value).slice(11, 16) : "—");

// قائمة حضور اليوم: النقر على الموظف يقرّب الخريطة على موقع تسجيله.
export const LivePeopleList = ({ people, onFocus }) => {
  const { t } = useTranslation();

  return (
    <NeuCard className="max-h-[32rem] overflow-y-auto p-4" data-testid="live-people">
      <p className="label-xs mb-3">{t("live.people")}</p>
      {people.length === 0 ? (
        <p className="text-xs text-muted-foreground" data-testid="live-people-empty">{t("live.empty")}</p>
      ) : null}
      <div className="grid gap-2">
        {people.map((person) => {
          const spot = person.check_in || person.check_out;
          const state = person.status === "absent"
            ? "absent"
            : person.check_out_at
              ? "checked_out"
              : person.late_minutes > 0
                ? "late"
                : "checked_in";
          return (
            <button
              key={person.user_id}
              type="button"
              disabled={!spot}
              data-testid={`live-person-${person.user_id}`}
              onClick={() => spot && onFocus(spot.longitude, spot.latitude)}
              className="flex items-center gap-3 rounded-2xl px-3 py-2 text-start shadow-neu-in transition-transform duration-300 enabled:hover:-translate-y-0.5 disabled:opacity-60"
            >
              <span className="min-w-0 flex-1">
                <span className="block truncate text-xs font-bold">{person.name}</span>
                <span className="block truncate text-[10px] text-muted-foreground">{person.job_title || "—"}</span>
              </span>
              <span className="font-mono text-[11px]" dir="ltr">
                {clock(person.check_in_at)} → {clock(person.check_out_at)}
              </span>
              <span className={`text-[10px] font-bold ${TONE[state]}`}>{t(`live.state.${state}`)}</span>
            </button>
          );
        })}
      </div>
    </NeuCard>
  );
};
